#### Home location in Optimised Apply

A candidate can add a home location to their SEEK Profile.
We have added support to retrieve this attribute from a job application in [Optimised Apply](/use-cases/application-export).

```graphql
query ($id: String!) {
  candidateProfile(id: $id) {
    candidate {
      person {
        communication {
          address {
            # Select other address fields as necessary
            formattedAddress
            countryCode
          }
        }
      }
    }
  }
}
```

```json
{
  "id": "seekAnzPublicTest:candidateProfile:apply:5G5NaFDmy7UigvGy6aT6VT"
}
```

```json
{
  "candidateProfile": {
    "candidate": {
      "person": {
        "communication": {
          "address": [
            {
              "formattedAddress": "Coober Pedy SA 5723 AU",
              "countryCode": "AU"
            }
          ]
        }
      }
    }
  }
}
```

A home location may be as specific as a suburb (`Cremorne VIC 3121 AU`),
or as broad as a country (`Poland`).
If you wish to use this attribute,
your software will need to account for these differences in granularity.
You may retrieve other [address](/schema/named-type/Address) fields as appropriate;
note that street-level detail is not currently available.
